import { MakeCall } from 'ha/services/apiV2/createMakeCall';

const logout = (makeCall: MakeCall) => () =>
  makeCall<undefined>('POST', `/api/v2/action/logout`);

export default logout;
